import { isNumber } from './is-number.es.js';
var isEasingList = function isEasingList(easing) {
  return Array.isArray(easing) && !isNumber(easing[0]);
};
export { isEasingList };